module.exports = __webpack_public_path__ + "static/media/logo-light-en.bf2c2745.svg";